import { Box } from '@hopskipdrive/react-components';
import { variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

const { colorPalette } = variables;

export const FormContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TableContainer = styled(Box)`
  border: 1px solid ${colorPalette.neutralVariant90};
  border-radius: 4px;
  overflow: hidden;
`;

export const SelectionBanner = styled(Box)`
  display: flex;
  align-items: center;
  background-color: ${colorPalette.blue98};
  border-radius: 5px;
  margin: 10px;
  min-height: 60px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 400;
  color: ${colorPalette.neutral10};
`;

export const TableBody = styled(Box)`
  max-height: 400px; /* Accommodates 5 rows including error states */
  overflow-y: auto;

  ${variables.mediaQuery.lessThan('desktop')`
    min-width: 840px;
  `}
`;

export const TableHeader = styled(Box)`
  display: grid;
  grid-template-columns: 52px 1fr 1fr 160px 180px 180px;
  padding: 0 16px;
  border-bottom: 1px solid ${colorPalette.neutralVariant90};
  background-color: ${colorPalette.neutral100};
`;

export const TableHeaderCell = styled.span`
  font-weight: 400;
  font-size: 13px;
  color: ${colorPalette.neutral10};
  padding: 16px 0;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const RequiredMark = styled.span`
  color: ${colorPalette.red43};
`;

export const TableRow = styled(Box)<{ $selected?: boolean }>`
  display: grid;
  grid-template-columns: 52px 1fr 1fr 160px 180px 180px;
  padding: 8px 16px;
  align-items: flex-start;
  border-bottom: 1px solid ${colorPalette.neutralVariant90};
  background-color: ${({ $selected }) => ($selected ? 'rgba(29, 75, 122, 0.04)' : 'transparent')};

  &:last-child {
    border-bottom: none;
  }

  ${variables.mediaQuery.lessThan('desktop')`
    grid-template-columns: 40px 150px 150px 140px 140px 180px;
    min-width: 840px;
  `}
`;

export const TableCell = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 4px 8px 4px 0;
  min-width: 0;

  &:last-child {
    padding-right: 0;
  }
`;

export const CheckboxCell = styled(Box)`
  display: flex;
  align-items: center;
  padding: 4px 0;
  min-width: 0;
`;
